<div class="ocr-pane">
  <div class="ocr-pane-head">
    <div>
      <p class="step">Step 1 — Capture</p>
      <h2>Bring a scanned application in</h2>
    </div>
  </div>

  @if (error()) {
    <p class="ocr-msg error">{{ error() }}</p>
  } @else if (message()) {
    <p class="ocr-msg">{{ message() }}</p>
  }

  <div class="flow-strip">
    <div class="flow-step on">
      <span class="flow-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12" /><path d="m7 8 5-5 5 5" /><path d="M5 21h14" /></svg>
      </span>
      <span class="flow-text">
        <strong>1. Upload</strong>
        <span>Drop or pick a scan</span>
      </span>
    </div>
    <span class="flow-arrow" aria-hidden="true"></span>
    <div class="flow-step">
      <span class="flow-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a10 10 0 1 0 10 10" /><path d="M12 2v10l7 3" /></svg>
      </span>
      <span class="flow-text">
        <strong>2. Extract</strong>
        <span>Reads &amp; matches</span>
      </span>
    </div>
    <span class="flow-arrow" aria-hidden="true"></span>
    <div class="flow-step">
      <span class="flow-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 12 2 2 4-4" /><circle cx="12" cy="12" r="9" /></svg>
      </span>
      <span class="flow-text">
        <strong>3. Review</strong>
        <span>Confirm into a case</span>
      </span>
    </div>
  </div>

  <div
    class="dropzone"
    [class.over]="dragOver()"
    [class.busy]="uploading()"
    (dragover)="$event.preventDefault(); dragOver.set(true)"
    (dragleave)="dragOver.set(false)"
    (drop)="onDrop($event)"
    (click)="openFilePicker()"
    role="button"
    tabindex="0"
    (keydown.enter)="openFilePicker()"
  >
    @if (uploading()) {
      <span class="dropzone-icon spinning" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 12a9 9 0 1 1-3.5-7.14" /></svg>
      </span>
      <strong>Uploading…</strong>
      <span>Reading the document and extracting cases — this can take a little while.</span>
    } @else {
      <span class="dropzone-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14.9A5 5 0 0 1 6 5.3a6 6 0 0 1 11.3-1.8A5.5 5.5 0 0 1 19 14" /><path d="M12 12v9" /><path d="m8.5 15.5 3.5-3.5 3.5 3.5" /></svg>
      </span>
      <strong>Drop a file, or click to choose one</strong>
      <span>PDF · JPG · PNG · WEBP</span>
    }
  </div>
  <input
    #fileInput
    class="sr-only"
    type="file"
    accept=".pdf,.jpg,.jpeg,.png,.webp,image/*,application/pdf"
    (change)="onFiles($any($event.target).files)"
  />
</div>
